export default __webpack_public_path__ + "static/media/monitor.d7918c2f.jpg";